(function () {
  'use strict';

  angular
    .module('relatorios.videoLibrary', [
      'ui.router',
      'angularMoment',
      'v3gAuthenticatorModule',
      'pascalprecht.translate'
    ]);
}());
